import * as types from "./types";

export const getUsersRequest = () => ({
  type: types.GET_USERS_REQUEST
});
export const addUsersResponse = (data) => ({
  type: types.ADD_USERS_RESPONSE,
  payload: data
});
